import { FilesPage } from "@onesolution/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_layout/files")({
	component: FilesPage,
});
